// The client side of /api/buying-groups (BUILD-BRIEF-R2 §10) — owned by the `buying-groups` agent.
// STUB: shapes final, route 501 until wave 2.
import { qs, request } from './client.js';
import type { BuyingGroupMember, BuyingRole, Coverage, ListResponse, Stance } from '../../shared/types.js';

export function listMembers(opportunityId: number): Promise<ListResponse<BuyingGroupMember>> {
  return request(`/buying-groups${qs({ opportunity_id: opportunityId })}`);
}

export function addMember(input: {
  opportunity_id: number; person_id: number; role: BuyingRole; stance?: Stance; note?: string;
}): Promise<BuyingGroupMember> {
  return request('/buying-groups', { method: 'POST', body: JSON.stringify(input) });
}

export function updateMember(id: number, patch: { role?: BuyingRole; stance?: Stance; note?: string }): Promise<BuyingGroupMember> {
  return request(`/buying-groups/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });
}

export function removeMember(id: number): Promise<void> {
  return request(`/buying-groups/${id}`, { method: 'DELETE' });
}

/** Arithmetic over six roles — the card shows it as a figure with NO claim mark. */
export function coverage(opportunityId: number): Promise<Coverage> {
  return request(`/buying-groups/coverage/${opportunityId}`);
}
